export default __webpack_public_path__ + "static/media/collagen-drinking@2x.1d1f2e5e.jpg";